import { transformColor } from '@amityeko/pbc-core/dist/utilities/color';
export function generateCustomColors(variant, color) {
    if (!color)
        return {};
    if (variant === 'primary') {
        return {
            '--private-bg-color': color,
            '--private-bg-color-hover': transformColor(color, 6, 7),
            '--private-bg-color-active': transformColor(color, 6, 8),
            '--private-bg-color-disabled': transformColor(color, 6, 3),
        };
    }
    if (variant === 'secondary') {
        return {
            '--private-color': color,
            '--private-color-hover': color,
            '--private-bg-color-hover': transformColor(color, 7, 3),
            '--private-color-active': color,
            '--private-bg-color-active': transformColor(color, 7, 4),
            '--private-color-disabled': transformColor(color, 7, 4),
        };
    }
    if (variant === 'ghost') {
        return {
            '--private-color': color,
            '--private-color-hover': color,
            '--private-bg-color-hover': transformColor(color, 7, 3),
            '--private-color-active': color,
            '--private-bg-color-active': transformColor(color, 7, 4),
            '--private-color-disabled': transformColor(color, 7, 4),
        };
    }
    if (variant === 'floating') {
        return {
            '--private-color': color,
            '--private-bg-color-hover': transformColor(color, 6, 1),
            '--private-bg-color-active': transformColor(color, 6, 2),
            '--private-color-disabled': transformColor(color, 6, 3),
        };
    }
    if (variant === 'danger') {
        return {
            '--private-bg-color': color,
            '--private-bg-color-hover': transformColor(color, 6, 7),
            '--private-bg-color-active': transformColor(color, 6, 8),
            '--private-bg-color-disabled': transformColor(color, 6, 3),
        };
    }
    return {};
}
//# sourceMappingURL=helpers.js.map